<template>
  <div class="modal-box-pro">
    <div class="modal-box-con">
      <div class="promotion-img-head"></div>
      <div class="promotion-img-headline"></div>
      <div class="promotion-txt">
        <p class="promotion-txt-head">活动时间：</p>
        <p class="promotion-txt-detail">即日起</p>
        <p class="promotion-txt-head">活动规则：</p>
        <p class="promotion-txt-detail">新会员注册并完善个人资料，获得200积分奖励！老会员完</p>
        <p class="promotion-txt-detail">善个人资料，获得100积分奖励！积分在任意积惠多会员门</p>
        <p class="promotion-txt-detail">店及线上商城消费时，可当现金直接抵扣哦！</p>
        <div class='promotion-button'>
          <!-- <p class="promotion-txt-join" bindtap='promotionJoin'></p> -->
          <button class="promotion-button-join" @click='promotionJoin'>立即参与</button>
        </div>
      </div>

      <div class="promotion-button-close" @click='promotionClose'></div>
    </div>
  </div>
</template>
<script>

export default {
  name: '',
  components:{

  },
  data () {
    return {
      title: '',
    }
  },
  methods: {
    promotionClose(){
      this.$emit("closePop")
    },
    promotionJoin(){
      this.$emit("closePop")
      this.$navigateTo("memberDetail",{urlstr:"memberDetail"})
    }
  }
}
</script>
<style scoped lang='less'>
.modal-box-pro {
  // top: 0px;
  overflow: hidden;
  z-index: 500;
  padding-top:0.5333rem;
  
}
.modal-box-con{
  width: 8.1333rem;
  height: 7.5733rem;
  background:url("../../assets/images/POP-upwindow.png") no-repeat;
  background-size:100% 100%;
  margin:0 auto;
  position:relative;
}
.promotion-txt {
  // position: absolute;
  width: 7.2rem;
  // height: 100%;
  // top: 450rpx;
  z-index: 600;
  margin: 0 auto;
  // left: 50%;
  // transform: translate(-50%, 0);
}

.promotion-txt-head {
  font-family: PingFang-SC-Medium, "Source Han Sans CN Medium",
    "Noto Sans CJK SC Medium";
  color: rgb(235, 97, 18);
  font-size: 13px;
  text-align: left;
  margin-top: 0.2667rem;
}

.promotion-txt-detail {
  font-family: PingFang-SC-Regular, "Source Han Sans CN Regular",
    "Noto Sans CJK SC Regular";
  color: rgb(151, 151, 151);
  font-size: 10px;
  text-align: left;
  line-height:14px;
}

.promotion-txt-join {
  font-family: PingFang-SC-Medium, "Source Han Sans CN Medium",
    "Noto Sans CJK SC Medium";
  color: rgb(255, 255, 255);
  font-size: 17px;
  text-align: center;
  margin-top: 0rpx;
  z-index: 900;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.promotion-img-head {
  position:relative;
  margin-left:2.8267rem;
  top:-0.2667rem;
  width: 3.5733rem;
  height: 1.96rem;
  background: url('../../assets/images/pic-head.png') no-repeat;
  background-size:100% 100%;
}

.promotion-img-headline {
  width: 4.2667rem;
  height: 0.8533rem;
  background: url('../../assets/images/pop-headline.png') no-repeat;
  background-size:100% 100%;
  margin:0 auto;
}
.promotion-button-join {
  width: 5.6rem;
  height: 0.9333rem;
  z-index: 999;
  background: -webkit-linear-gradient(
    270deg,
    rgba(255, 195, 92, 1) 0%,
    rgba(254, 97, 65, 1) 100%
  );
  background: linear-gradient(
    270deg,
    rgba(255, 195, 92, 1) 0%,
    rgba(254, 97, 65, 1) 100%
  );
  border:none;
  text-align:center;
  color:#fff;
  border-radius: 4px;
  margin-top:0.4267rem;
}
.promotion-button-join::before {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    background-color: #000;
    border: inherit;
    border-color: #000;
    border-radius: inherit;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    opacity: 0;
    content: ' ';
}

.promotion-button-close {
  width: 0.6667rem;
  height: 0.6667rem;
  position: absolute;
  top: 0;
  right: 0.4267rem;
  z-index: 999;
  background: url("../../assets/images/close.png") no-repeat;
  background-size: 100% 100%;
}

.promotion-button {
  text-align: center;
  width: 100%;
  // height: 80rpx;
  position: relative;
  // top: 30rpx;
}

</style>